import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ApiHelperFunction } from '../Helper/Helper';

const initialState = {
  status: false,
  categoryAdd: '',
  parentIds: [],
  categoryList: [],
  SubcategoryList: [],
  ActivecategoryList: [],
  catId: []

};

export const CreateCategory = createAsyncThunk('/Create', async (data) => {
  const response = await ApiHelperFunction({
    urlPath: 'category',
    method: 'POST',
    formData: data,
  });

  return response;
});

export const getCategoryList = createAsyncThunk('/list', async (data) => {
  const response = await ApiHelperFunction({
    urlPath: 'category/list?' + data,
    method: 'POST',
  });
  return response;
});

export const getSubCategoryList = createAsyncThunk('/sublist', async ({ data, id }) => {

  const response = await ApiHelperFunction({
    urlPath: 'category/list?' + data,
    method: 'POST',
    formData: { "parentId": id }
  });
  return response;
});

// CATEGORY DELETE
export const categoryDelete = createAsyncThunk('/categoryDelete', async (id) => {
  const response = await ApiHelperFunction({
    urlPath: 'category',
    method: 'DELETE',
    formData: id
  });

  return response;
});
// CATEGORY EDIT
export const categoryEdit = createAsyncThunk('/categoryEdit', async (id) => {
  const response = await ApiHelperFunction({
    urlPath: `category/${id}`,
    method: 'GET',
    // formData:id
  });

  return response;
});

export const CategoryTree = createAsyncThunk('/Caregorytree', async () => {
  const response = await ApiHelperFunction({
    urlPath: 'category/tree',
    method: 'GET',
  });

  return response;
});

// category

const Addinfo = (val, ids) => {
  if (!ids.includes(val)) {
    return [val, ...ids];
  } else {
    return ids.filter((data, id) => data !== val);
  }
};

export const CategorySlice = createSlice({
  name: 'Category',
  initialState,
  reducers: {
    addcategoryIds: (state, action) => {
      state.parentIds = Addinfo(action?.payload, state.parentIds);
    },
    setCategoryIdsfromApi: (state, action) => {
      state.parentIds = action?.payload;
    },
    //categorry tree
    setSelectedCategory: (state, action) => {
      state.catId = action?.payload;
    },
    updateSelectedCategory: (state, action) => {
      const updateCats = state.catId?.includes(action?.payload) ? state.catId?.filter(c => c !== action?.payload) : [...state.catId, action?.payload]
      state.catId = updateCats
    },
  },

  extraReducers: (builder) => {
    builder

      .addCase(CreateCategory.pending, (state) => {
        state.status = true;
      })
      .addCase(CreateCategory.fulfilled, (state, action) => {
        state.status = false;
      })
      .addCase(CreateCategory.rejected, (state, action) => {
        state.status = false;
      })
      // Category list
      .addCase(getCategoryList.pending, (state) => {
        state.status = true;
      })
      .addCase(getCategoryList.fulfilled, (state, action) => {
        state.status = false;
        state.categoryList = action?.payload?.data;
      })
      .addCase(getCategoryList.rejected, (state, action) => {
        state.status = false;
      })
      //  Sub Category list
      .addCase(getSubCategoryList.pending, (state) => {
        state.status = true;
      })
      .addCase(getSubCategoryList.fulfilled, (state, action) => {
        state.status = false;
        state.SubcategoryList = action?.payload?.data;
      })
      .addCase(getSubCategoryList.rejected, (state, action) => {
        state.status = false;
      });
  },
});

export default CategorySlice.reducer;
export const { addcategoryIds, setCategoryIdsfromApi, setSelectedCategory, updateSelectedCategory } = CategorySlice.actions;

export const selectedCategoryIds = state => state.Category.catId
